import styled, { css } from 'styled-components';
import { px2rem } from '../../helpers/rem.mjs';
import { B4RegularStyle, B3RegularStyle, B1RegularStyle } from '../typos.mjs';

function chipShapeGenerator(shape, size) {
  if (shape === "round") {
    switch (size) {
      case "large":
        {
          return css(["border-radius:", ";padding:", " ", ";", ";"], px2rem(15), px2rem(6), px2rem(16), B3RegularStyle);
        }
      case "medium":
        {
          return css(["border-radius:", ";padding:", " ", ";", ";"], px2rem(10.5), px2rem(1), px2rem(6), B3RegularStyle);
        }
      case "small":
        {
          return css(["border-radius:", ";padding:0 ", ";", ";"], px2rem(10), px2rem(4), B4RegularStyle);
        }
    }
  } else {
    switch (size) {
      case "large":
        {
          return css(["border-radius:", ";padding:", " ", ";", ";"], px2rem(2), px2rem(1), px2rem(8), B1RegularStyle);
        }
      case "medium":
        {
          return css(["border-radius:", ";padding:", " ", ";", ";"], px2rem(2), px2rem(1), px2rem(6), B3RegularStyle);
        }
      case "small":
        {
          return css(["border-radius:", ";padding:0 ", ";", ";"], px2rem(2), px2rem(4), B4RegularStyle);
        }
    }
  }
}
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-13vuqbq-0"
})(["display:inline-flex;outline:0;align-items:center;justify-content:center;vertical-align:middle;white-space:nowrap;text-decoration:none;cursor:", ";user-select:none;-webkit-tap-highlight-color:transparent;", ";", ";"], function (props) {
  return props.onClick ? "cursor" : "default";
}, function (props) {
  return chipShapeGenerator(props.shape, props.size);
}, function (props) {
  return props.overrideStyle;
});

export { Wrapper };
